import { client, handleRequestBody } from "./client.ts";

export interface WorksiteScheduleDay {
	weekday: number;
	starts_at: string | null;
	ends_at: string | null;
	break_minutes: number;
	expected_minutes: number;
}

export interface WorksiteTimeSettings {
	weekday_overtime_pct: number;
	saturday_overtime_pct: number;
	sunday_overtime_pct: number;
	holiday_overtime_pct: number;
	schedule: WorksiteScheduleDay[];
	persisted: boolean;
	updated_by_user_id: string | null;
	updated_at: string | null;
}

interface TimeSettingsResponse {
	time_settings: WorksiteTimeSettings;
}

export async function getTimeSettings(
	worksiteId: string,
): Promise<WorksiteTimeSettings> {
	const { time_settings } = await handleRequestBody(() =>
		client.get<TimeSettingsResponse>(`/worksites/${worksiteId}/time-settings`),
	);
	return time_settings;
}

export interface ScheduleDayInput {
	weekday: number;
	starts_at: string | null;
	ends_at: string | null;
	break_minutes: number;
}

export interface PutTimeSettingsInput {
	weekday_overtime_pct: number;
	saturday_overtime_pct: number;
	sunday_overtime_pct: number;
	holiday_overtime_pct: number;
	schedule: ScheduleDayInput[];
}

export async function putTimeSettings(
	worksiteId: string,
	input: PutTimeSettingsInput,
): Promise<WorksiteTimeSettings> {
	const { time_settings } = await handleRequestBody(() =>
		client.put<TimeSettingsResponse>(
			`/worksites/${worksiteId}/time-settings`,
			input,
		),
	);
	return time_settings;
}
